export const getJobAdLocations = ({ locations = [], places = [] } = {}) => {
  if (places?.length > 0) {
    return places.map((place) => ({
      id: place.place_id,
      name: place.name,
      Code: '',
      countryCode: place.country_code,
    }));
  }

  return (locations ?? []).map((location) => ({
    ...location,
    countryCode: location.Code?.slice(0, 2),
  }));
};

export const formatJobAdLocation = (location) => (location.Code ? `${location.name} (${location.Code})` : location.name);

export const formatJobAdLocationShort = (location) =>
  location.countryCode ? `${location.name} (${location.countryCode})` : location.name;

export const usesNutsLocations = (company) =>
  ['buyer', 'main_buyer'].includes(company?.Type) && company?.sector === 'public';

export const toPlaceInputs = (places = []) => (places ?? []).map(({ place_id, name }) => ({ place_id, name }));
